/**
 * Simplified Mapbox loader using npm packages
 * Provides lazy loading support while using bundled modules
 */

// Cache for loaded modules
let mapboxModule: typeof import('mapbox-gl') | null = null;
let reactMapGLModule: typeof import('react-map-gl') | null = null;

/**
 * Load Mapbox GL JS from npm package
 */
export const loadMapboxLibraries = async () => {
  try {
    // Load modules if not already cached
    if (!mapboxModule) {
      mapboxModule = await import('mapbox-gl');
    }
    
    if (!reactMapGLModule) {
      reactMapGLModule = await import('react-map-gl');
    }
    
    return {
      mapbox: mapboxModule,
      reactMapGL: reactMapGLModule,
    };
  } catch (error) {
    console.error('Failed to load Mapbox libraries:', error);
    throw error;
  }
};

/**
 * Check if Mapbox libraries are already loaded
 */
export const isMapboxLoaded = (): boolean => {
  return mapboxModule !== null && reactMapGLModule !== null;
};

/**
 * Get loaded Mapbox modules (throws if not loaded)
 */
export const getMapboxModules = () => {
  if (!mapboxModule || !reactMapGLModule) {
    throw new Error('Mapbox libraries not loaded. Call loadMapboxLibraries() first.');
  }
  
  return {
    mapbox: mapboxModule,
    reactMapGL: reactMapGLModule,
  };
};